/* eslint-disable jsx-a11y/no-onchange */
import React from 'react';
import PropTypes from 'prop-types';

function TimeSelector({
  selectedDate,

  OptionsHours,
  handleSelectHour,

  OptionsMinutes,
  handleSelectMinute,
}) {
  return (
    <React.Fragment>
      {/* Hours */}
      <select
        value={(selectedDate && selectedDate.getHours()) || ''}
        className="select-time"
        onChange={handleSelectHour}
      >
        {OptionsHours}
      </select>
      <span>h</span>
      {/* Minutes */}
      <select
        value={(selectedDate && selectedDate.getMinutes()) || ''}
        className="select-time"
        onChange={handleSelectMinute}
      >
        {OptionsMinutes}
      </select>
    </React.Fragment>
  );
}

TimeSelector.propTypes = {
  selectedDate: PropTypes.instanceOf(Date).isRequired,

  OptionsHours: PropTypes.arrayOf(PropTypes.node).isRequired,
  handleSelectHour: PropTypes.func.isRequired,

  OptionsMinutes: PropTypes.arrayOf(PropTypes.node).isRequired,
  handleSelectMinute: PropTypes.func.isRequired,
};

export default TimeSelector;



// WEBPACK FOOTER //
// ./components/core/DateTimePicker2/components/TimeSelector.js